import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './client';

// Server: `Map<String, Long>` (economy/WalletController.java) — genuinely open, and has been
// since Phase 3: `LedgerService.balances` returns EVERY currency registered in the content-driven
// currency catalog (`catalog.currencyTypes().codes()`, defaulted to 0), not just shells/motes.
// Phase 7 Task 13 widening: this type used to be closed to exactly `{shells, motes}` (the task-15
// brief's own contract table, when those were the only two registered currencies) — a liveops
// event's own currency (e.g. `lantern_sparks`, content/packs/core.v1/currencies/lantern_sparks.json)
// now also rides in this same response while its owning event is active (present at 0 even when
// inactive, per `LedgerService.balances`' own "every registered code, defaulted to 0" contract).
// `shells`/`motes` stay named, non-optional keys — every existing consumer that reads them
// directly keeps its exact prior guarantee — widened with an index signature so a caller that
// knows a currency code (`ShellsHud`/`ShopScreen`/`lib/currency.ts`'s own `eventCurrencyCode`) can
// read it too, without this type ever becoming a general N-currency framework on its own.
export type WalletDto = {
  shells: number;
  motes: number;
} & Record<string, number>;

export const walletKeys = {
  all: ['wallet'] as const,
};

export const getWallet = () => apiFetch<WalletDto>('/wallet');

export function useWallet() {
  return useQuery({ queryKey: walletKeys.all, queryFn: getWallet });
}
